import { Form, Input, Select, Col, Row, Card, DatePicker } from "antd";
import React, { useEffect, useRef, useState } from "react";
import constants from "../../../../constants";
import { IDriverByIdResponse } from "../../../../types/driver";
import ServiceType from "../../../addDriverCheckBox/ServiceType";
import { UploadImage } from "../../../axios/imageUpload";
import { useGetVehiclesQuery } from "../../../../feature/Driver/driverApiSlice";
import { useGetAllCategoryQuery } from "../../../../feature/Category/categoryApiSlice";
import dayjs from 'dayjs';
import { handleImageSize } from "../../../../utils/handleImageSize";
import { EyeOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import eyeIcon from "../../../../assets/eyeIcon.svg";

type VehicleDetailsProps = {
  data?: IDriverByIdResponse;
  setRCImage?: any;
  setRCBackImage?: any;
  setTouristPermitBackImage?: any;
  setTouristPermitFrontImage?: any;
  vehicleDetailsResponse?: any;
  readOnly?: boolean;
};
const imageUploaderStyle = {
  width: "12rem",
  height: "8rem",
};
export default function VehicleDetails(props: VehicleDetailsProps) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const {
    data,
    setRCImage,
    setRCBackImage,
    setTouristPermitFrontImage,
    setTouristPermitBackImage,
    vehicleDetailsResponse,
  } = props;

  const [isPreviewVisible, setIsPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const handlePreview = (imageUrl: string) => {
    setPreviewImage(imageUrl);
    setIsPreviewVisible(true);
  };
  const handleCancelPreview = () => {
    setIsPreviewVisible(false);
    setPreviewImage("");
  };

  const [vehicleState, setVehicleState] = useState([]);
  const [vehicleCategoryState, setVehicleCategoryState] = useState<any[]>([]);
  const [vehicleMakeId, setVehicleMakeId] = useState<string>("");
  const fileInputRef = useRef<HTMLInputElement>(null); // <-- Added ref
  const rcBackInputRef = useRef<HTMLInputElement>(null); // <-- RC back input ref
  const [isHovered, setIsHovered] = useState(false);
  const [isBackHovered, setIsBackHovered] = useState(false);
  const [selectedServices, setSelectedServices] = useState<string[]>([]);
  const [vehicleModelState, setVehicleModel] = useState([]);
  const [rcImgFront, setRcImgFront] = useState({
    image_file: '',
    image_preview: "",
  });
  const [rcImgBack, setRcImgBack] = useState({
    image_file: '',
    image_preview: "",
  });
  const [permitFrontImg, setPermitFrontImg] = useState({
    fImage_file: '',
    fImage_preview: "",
  });
  const [permitBackImg, setPermitBackImg] = useState({
    bImage_file: '',
    bImage_preview: "",
  });
  const inputFileLabelStyle: React.CSSProperties = {
  width: "60%",
  padding: "4px",
  background: "#3e4685",
  borderRadius: "5px",
  border: "5px",
  color: "white",
  cursor: "pointer",
  display: "inline-block",
  marginTop: "0.5rem",
  textAlign: "center",
  fontSize: "16px",
  transition: "background-color 0.3s ease",
  marginLeft: "15px",
};
  const rcImgHandler = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
  
      const resultImage= await handleImageSize(file);

      if(resultImage!==undefined){
        const compressedFile:File=resultImage;
        const image_as_base64 = URL.createObjectURL(compressedFile);
  
        let fd = new FormData();
        fd.append('image', compressedFile);

        UploadImage(fd)
          .then((res) => {
            setRcImgFront({
              image_preview: image_as_base64,
              image_file: res.data,
            });
            setRCImage(res.data.url || res.data);
          })
          .catch((err) => {
            console.log(err);
          });
        }
    }
  };
  const frontImgHandler = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const resultImage= await handleImageSize(file);

      if(resultImage!==undefined){
        const compressedFile:File=resultImage;
        const image_as_base64 = URL.createObjectURL(compressedFile);
  
        let fd = new FormData();
        fd.append('image', compressedFile);

        UploadImage(fd)
          .then((res) => {
            setPermitFrontImg({
              fImage_preview: image_as_base64,
              fImage_file: res.data,
            });
            setTouristPermitFrontImage(res.data.url || res.data);
          })
          .catch((err) => {
            console.log(err);
          });
        }
    }
  };
  const rcBackImgHandler = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
  
      const resultImage= await handleImageSize(file);

      if(resultImage!==undefined){
        const compressedFile:File=resultImage;
        const image_as_base64 = URL.createObjectURL(compressedFile);
  
        let fd = new FormData();
        fd.append('image', compressedFile);

        UploadImage(fd)
          .then((res) => {
            setRcImgBack({
              image_preview: image_as_base64,
              image_file: res.data,
            });
            setRCBackImage(res.data.url || res.data);
          })
          .catch((err) => {
            console.log(err);
          });
        }
    }
  };
  const backImgHandler = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
  
      const resultImage= await handleImageSize(file);

      if(resultImage!==undefined){
        const compressedFile:File=resultImage;
        const image_as_base64 = URL.createObjectURL(compressedFile);
  
        let fd = new FormData();
        fd.append('image', compressedFile);

        UploadImage(fd)
          .then((res) => {
            setPermitBackImg({
              bImage_preview: image_as_base64,
              bImage_file: res.data,
            });
            setTouristPermitBackImage(res.data.url || res.data);
          })
          .catch((err) => {
            console.log(err);
          });
        }
    }
  };

  const { data: vehicles } = useGetVehiclesQuery();
  const { data: categoriesData } = useGetAllCategoryQuery();
  
  useEffect(() => {
    const vehicleMake = vehicles?.data?.map((item: any) => (
      {
        id: item.id,
        name: item.vehicleMake
      }
    ));
    setVehicleState(vehicleMake);
  }, [vehicles]);

  useEffect(() => {
    // Fetch categories from Category API
    const categories = categoriesData?.data?.content?.map((cat: any) => ({
      id: cat.id,
      name: cat.categoryName || cat.name || cat.id
    })) || [];
    setVehicleCategoryState(categories);
  }, [categoriesData]);

  // useEffect(() => {
  //   vehicles?.data?.find((item: any) => {
  //     if (item.id === vehicleMakeId) {
  //       setVehicleModel(item.vehicleModel.map((model: any) => { return { id: model, name: model }; }));
  //     }
  //     return item;
  //   });
  // }, [vehicleMakeId, vehicles, vehicleModelState]);

  useEffect(() => {
    setRcImgFront({
      image_file: `${data?.data.vehicleDto.rcImage.rcFrontImage}`,
      image_preview: `${data?.data.vehicleDto.rcImage.rcFrontImage}`,
    });
    setRCImage(data?.data.vehicleDto.rcImage.rcFrontImage);

    setRcImgBack({
      image_file: `${data?.data.vehicleDto.rcImage.rcBackImage}`,
      image_preview: `${data?.data.vehicleDto.rcImage.rcBackImage}`,
    });

    setPermitFrontImg({
      fImage_preview: `${data?.data.vehicleDto.touristPermitDTO.touristPermitFrontImage}`,
      fImage_file: `${data?.data.vehicleDto.touristPermitDTO.touristPermitFrontImage}`,
    });
    setTouristPermitFrontImage(data?.data.vehicleDto.touristPermitDTO.touristPermitFrontImage);

    setPermitBackImg({
      bImage_preview: `${data?.data.vehicleDto.touristPermitDTO.touristPermitBackImage}`,
      bImage_file: `${data?.data.vehicleDto.touristPermitDTO.touristPermitBackImage}`,
    });
    setTouristPermitBackImage(data?.data.vehicleDto.touristPermitDTO.touristPermitBackImage);
    
    // Initialize selectedServices with existing data
    if (data?.data.vehicleDto.taxiServiceTypeDTOList) {
      setSelectedServices(data.data.vehicleDto.taxiServiceTypeDTOList);
    }

    if (data?.data) {
      form.setFieldsValue({
        vehicleCategory: (data as any)?.data?.categoryName,
        vehicleMake: data.data.vehicleDto.vehicleMake?.[0]?.id,
        vehicleYear: dayjs(data.data.vehicleDto.vehicleYear.toString()),
        vehicleModel: data.data.vehicleDto.vehicleModel,
        vehicleNumber: data.data.vehicleDto.vehicleNumber,
        fuelType: data.data.vehicleDto.fuelType,
        rcNumber: data.data.vehicleDto.rcImage.rcNumber,
        rcFrontImage: data.data.vehicleDto.rcImage.rcFrontImage,
        rcBackImage: data.data.vehicleDto.rcImage.rcBackImage,
        taxiServiceTypeDTOList: data.data.vehicleDto.taxiServiceTypeDTOList,
        touristPermitDTO: {
          touristPermitNumber:
            data.data.vehicleDto.touristPermitDTO.touristPermitNumber,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);


  const [formData, setFormData] = useState({
    vehicleMake: "",
    vehicleModel: "",
    vehicleYear: "",
    fuelType: "",
    vehicleNumber: "",
    rcImage: {
      rcNumber: ""
    },
    taxiServiceTypeDTOList: "",

  });

  const handleFieldChange = (fieldName: any, value: any) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }));
    let res = Object.values(formData);
  };
  const handleService = (response: any) => {
    handleFieldChange("taxiServiceTypeDTOList", response[0]);
    setSelectedServices(response);
  };

  return (
    <>
      <Form
        form={form}
        name="vehicleDetailForm"
        initialValues={{
          vehicleCategory: (data as any)?.data?.categoryName,
          vehicleMake: data?.data.vehicleDto.vehicleMake?.[0]?.id,
          vehicleYear: dayjs(data?.data.vehicleDto.vehicleYear.toString()),
          vehicleModel: data?.data.vehicleDto.vehicleModel,
          vehicleNumber: data?.data.vehicleDto.vehicleNumber,
          fuelType: data?.data.vehicleDto.fuelType,
          rcNumber: data?.data.vehicleDto.rcImage.rcNumber,
          rcFrontImage: data?.data.vehicleDto.rcImage.rcFrontImage,
          rcBackImage: data?.data.vehicleDto.rcImage.rcBackImage,
          taxiServiceTypeDTOList: data?.data.vehicleDto.taxiServiceTypeDTOList,
          touristPermitDTO: {
            touristPermitNumber:
              data?.data.vehicleDto.touristPermitDTO.touristPermitNumber,
          }
        }}
      >
        <Row gutter={[32, 22]}>
          <Col span={12}>
            <Row>
              <Col span={24}>
                <label>Vehicle Make</label>
                <Form.Item
                  name="vehicleMake"
                  rules={[
                    { required: true, message: "Vehicle Make is required" },
                  ]}
                >
                  <Select onSelect={(e) => {
                    handleFieldChange("vehicleMake", e);
                    vehicles?.data?.filter((item: any) => {
                      if (item.id === e) {
                        setVehicleModel(item.vehicleModel.map((model: any) => { return { id: model, name: model }; }));
                      }
                      return item;
                    });
                  }}>
                    {
                      !!vehicleState && vehicleState.map((vehicle: any) => {
                        return (
                          <Option key={vehicle.id} value={vehicle.id}>
                            {vehicle.name}
                          </Option>
                        );
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <label>Vehicle Category</label>
                <Form.Item
                  name="vehicleCategory"
                  rules={[{ required: true, message: "Vehicle Category is required" }]}
                >
                  <Select
                    onChange={(e) => handleFieldChange("vehicleCategory", e)}
                    disabled={props.readOnly}
                  >
                    {
                      !!vehicleCategoryState && vehicleCategoryState.map((c: any) => (
                        <Option key={c.id} value={c.name}>
                          {c.name}
                        </Option>
                      ))
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <label>Vehicle Model</label>
                <Form.Item
                  name="vehicleModel"
                  rules={[
                    { required: true, message: "Vehicle Model is required" },
                  ]}
                >
                  <Select
                    onChange={(e) => {
                      handleFieldChange("vehicleModel", e);
                    }}
                  >
                    {
                      !!vehicleModelState && vehicleModelState.map((v: any) => {
                        return (
                          <Option key={v.id} value={v.id}>{v.name}</Option>
                        );
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <label>Vehicle year</label>
                <Form.Item
                  name="vehicleYear"
                  rules={[
                    { required: true, message: "Vehicle year is required" },
                  ]}
                >
                  <DatePicker picker="year" style={{ width: "100%" }} onChange={(e) => handleFieldChange("vehicleYear", e)} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <label>Fuel Type</label>
                <Form.Item
                  name="fuelType"
                  rules={[{ required: true, message: "Fuel Type is required" }]}
                >
                  <Select onChange={(e) => handleFieldChange("fuelType", e)}>
                    <Option value="PETROL">Petrol</Option>
                    <Option value="DIESEL">Diesel</Option>
                    <Option value="CNG">CNG</Option>
                  </Select>
                </Form.Item>
              </Col>

              <label>Service Type</label>
              <div className="borderBoxService">
                <ServiceType handleService={handleService} />
              </div>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={24}>
                <label>Vehicle Number</label>
                <Form.Item
                  name="vehicleNumber"
                  rules={[
                    {
                      required: true,
                      message: "Vehicle Number is required",
                    },
                  ]}
                >
                  <Input
                    className="borderb"
                    onChange={(e) =>
                      handleFieldChange("vehicleNumber", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <label>Vehicle Registration Certificate</label>
                <div className="borderBoxPermit">
                  {/* <Form.Item
                    name="rcNumber"
                    rules={[
                      { required: true, message: "Vehicle RC is required" },
                    ]}
                  >
                    <Input
                      onChange={(e) =>
                        handleFieldChange("rcNumber", e.target.value)
                      }
                    />
                  </Form.Item> */}
                  <Row>
                    <Col span={12}>
                      <Card>
                        <img
                          src={rcImgFront.image_preview}
                          alt=" RC Img"
                          style={imageUploaderStyle}
                        />
                        <img
                          src={eyeIcon}
                          alt="Preview Icon"
                          style={{
                            position: "absolute",
                            bottom: 35,
                            right: 60,
                            fontSize: "18px",
                            background: "white",
                            color: "black",
                            borderRadius: "50%",
                            padding: "4px",
                            boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                            cursor: "pointer",
                            width: "24px", // Adjust size as needed
                            height: "24px",
                          }}
                          onClick={() => handlePreview(rcImgFront.image_preview)}
                          
                        />
                      </Card>
                      <input
  type="file"
  name="rcImage.rcFrontImage"
  ref={fileInputRef}
  style={{ display: "none" }}
  onChange={rcImgHandler}
/>

<div
  onClick={() => fileInputRef.current?.click()}
  onMouseEnter={() => setIsHovered(true)}
  onMouseLeave={() => setIsHovered(false)}
  style={{
    ...inputFileLabelStyle,
    backgroundColor: isHovered ? "#4c9eff" : "#3e4685",
    color: "white",
  }}
>
  Upload RC Front
</div>

                    </Col>

                    <Col span={12}>
                      <Card>
                        <img
                          src={rcImgBack.image_preview}
                          alt=" RC Back Img"
                          style={imageUploaderStyle}
                        />
                        <img
                          src={eyeIcon}
                          alt="Preview Icon"
                          style={{
                            position: "absolute",
                            bottom: 35,
                            right: 60,
                            fontSize: "18px",
                            background: "white",
                            color: "black",
                            borderRadius: "50%",
                            padding: "4px",
                            boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                            cursor: "pointer",
                            width: "24px", // Adjust size as needed
                            height: "24px",
                          }}
                          onClick={() => handlePreview(rcImgBack.image_preview)}
                        />
                      </Card>
                      <input
  type="file"
  name="rcImage.rcBackImage"
  ref={rcBackInputRef}
  style={{ display: "none" }}
  onChange={rcBackImgHandler}
/>

<div
  onClick={() => rcBackInputRef.current?.click()}
  onMouseEnter={() => setIsBackHovered(true)}
  onMouseLeave={() => setIsBackHovered(false)}
  style={{
    ...inputFileLabelStyle,
    backgroundColor: isBackHovered ? "#4c9eff" : "#3e4685",
    color: "white",
  }}
>
  Upload RC Back
</div>

                    </Col>
                  </Row>
                </div>
              </Col>
              {selectedServices.includes("OUTSTATION_TAXI") ? (
                <Col span={24}>
                  <label>Tourist Permit</label>
                  <div className="borderBoxPermit">
                    <Form.Item
                      name={['touristPermitDTO', 'touristPermitNumber']}
                      rules={[
                        {
                          required: selectedServices.includes("OUTSTATION_TAXI"),
                          message: "Tourist Permit is required when Outstation service is selected",
                        },
                      ]}
                    >
                      <Input

                      />
                    </Form.Item>
                    <Row>
                      <Col span={12}>
                        <Card style={{ position: 'relative' }}>
                          <img
                            src={permitFrontImg.fImage_preview}
                            alt=" Front Img"
                            style={imageUploaderStyle}
                          />
                          <img
                            src={eyeIcon}
                            alt="Preview Icon"
                            style={{
                              position: "absolute",
                              bottom: 35,
                              right: 60,
                              fontSize: "18px",
                              background: "white",
                              color: "black",
                              borderRadius: "50%",
                              padding: "4px",
                              boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                              cursor: "pointer",
                              width: "24px",
                              height: "24px",
                            }}
                            onClick={() => handlePreview(permitFrontImg.fImage_preview)}
                          />
                        </Card>
                        <input
                          type="file"
                          className="custom-frontbtn"
                          name="touristPermitDTO.touristPermitFrontImage"
                          onChange={frontImgHandler}
                        />
                      </Col>

                      {/* <Col span={12}>
                        <Card style={{ position: 'relative' }}>
                          <img
                            src={permitBackImg.bImage_preview}
                            alt=" Back Img"
                            style={imageUploaderStyle}
                          />
                          <img
                            src={eyeIcon}
                            alt="Preview Icon"
                            style={{
                              position: "absolute",
                              bottom: 35,
                              right: 60,
                              fontSize: "18px",
                              background: "white",
                              color: "black",
                              borderRadius: "50%",
                              padding: "4px",
                              boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                              cursor: "pointer",
                              width: "24px",
                              height: "24px",
                            }}
                            onClick={() => handlePreview(permitBackImg.bImage_preview)}
                          />
                        </Card>
                        <input
                          type="file"
                          className="custom-backbtn"
                          name="touristPermitDTO.touristPermitBackImage"
                          onChange={backImgHandler}
                        />
                      </Col> */}
                    </Row>
                  </div>
                </Col>
              ) : (
                ""
              )}
            </Row>
          </Col>
          <Modal
            visible={isPreviewVisible}
            footer={null}
            onCancel={handleCancelPreview}
            centered
            width={600}
          >
            <img
              alt="Document Preview"
              style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
              src={previewImage}
            />
          </Modal>
        </Row>
      </Form>
    </>
  );
}
